module.exports = __webpack_public_path__ + "img/user_LiJingwei.cdb04357.png";